import { defineStore } from 'pinia';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';

export const useServiceStore = defineStore('service', {
  state: () => ({
    serviceAds: [],
    loading: false,
    error: null,
    hasFetched: false,
  }),
  actions: {
    async fetchServiceAds() {
      // If we already fetched them, avoid re-fetching to save Firestore reads
      if (this.hasFetched) return;
      
      this.loading = true;
      this.error = null;
      try {
        const servicesQuery = query(
          collection(db, 'services'),
          where('isActive', '==', true),
          where('isPublished', '==', true)
        );
        
        const querySnapshot = await getDocs(servicesQuery);
        this.serviceAds = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        this.hasFetched = true;
      } catch (err) {
        console.error('Error fetching service ads:', err);
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },
    // Force refresh if needed
    async refreshServiceAds() {
      this.hasFetched = false;
      await this.fetchServiceAds();
    }
  },
});
